import validateTextInput from '../validation_utils/validateTextInput'

export default function signUpEmailFormValidation () {
  const footerSignupEmailForm = Array.from(document.getElementsByClassName('vjs-footer-signup-email-form'))[0]
  const newsletterSignupEmailForm = Array.from(document.getElementsByClassName('vjs-newsletter-signup-email-form'))[0]
  const aboutUsSignupEmailForm = Array.from(document.getElementsByClassName('vjs-about-us-signup-email-form'))[0]
  const homepageSignupEmailForm = Array.from(document.getElementsByClassName('vjs-homepage-signup-email-form'))[0]
  if (footerSignupEmailForm) { addValidationToForm(footerSignupEmailForm, 'vjs-footer-signup-user-email') }

  if (newsletterSignupEmailForm) { addValidationToForm(newsletterSignupEmailForm, 'vjs-newsletter-signup-user-email') }

  if (aboutUsSignupEmailForm) { addValidationToForm(aboutUsSignupEmailForm, 'vjs-about-us-signup-user-email') }

  if (homepageSignupEmailForm) { addValidationToForm(homepageSignupEmailForm, 'vjs-homepage-signup-user-email') }
}

function addValidationToForm (emailForm, emailInputId) {
  ['change', 'submit'].forEach(formEvent => {
    emailForm.addEventListener(formEvent, event => {
      validateTextInput(event, emailInputId, setEmailValidationErrorText)
    })
  })
}

function setEmailValidationErrorText (validityObject, errorEl) {
  console.log('setEmailValidationErrorText1')
  const { valueMissing, typeMismatch } = validityObject

  if (valueMissing) {
    errorEl.textContent = 'You need to enter an e-mail address'
  } else if (typeMismatch) {
    errorEl.textContent = 'The entered value is not an e-mail address'
  }
}
